import NoticeBar from './notice-bar';
export default NoticeBar;
